<template>
  <div class="form-control">
    <input
      class="file-input file-input-bordered w-full"
      type="file"
      accept="image/*"
      @change="handleFileUpload"
    />
    <div v-if="previewUrl" class="mt-3">
      <img
        :src="previewUrl"
        alt="Preview"
        class="w-32 h-auto rounded shadow border border-base-300"
      />
    </div>
  </div>
</template>


<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{ modelValue: string | null }>();
const emit = defineEmits(["update:modelValue"]);

const previewUrl = ref(props.modelValue || "");

function handleFileUpload(event: Event) {
  const file = (event.target as HTMLInputElement)?.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      previewUrl.value = reader.result as string;
      emit("update:modelValue", previewUrl.value);
    };
    reader.readAsDataURL(file);
  }
}
</script>
